export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.logout.label': 'Logout',
  'component.siteSelector.playerPlaceholder': 'Select a player...',
  'component.siteSelector.loadingSites': 'Loading Players...',
  'component.siteSelector.currentSiteLobby': 'Site Lobby',
  'component.siteSelector.refresh': 'Refresh Players',
  'component.siteSelector.playerIdentifier': 'Players',
  'component.gameLaunch.copySuccess': 'URL copied to clipboard',
  'component.gameLaunch.copyFailed': 'Failed to copy URL',
  'component.gameLaunch.openNewWindow': 'Play in New Window',
  'component.gameLaunch.copyUrl': 'Copy URL',
  'component.gameLaunch.scanOrPress': 'Scan QR code or click below to play',
  'component.gameLaunch.sessionID': 'Session ID:',
  'component.gameLaunch.goToMonitor': 'Go to Monitor',
  'component.gameLaunch.copyToken': 'Copy token',
  'component.gameLaunch.mobileScanInstruction':
    'Scan QR code with your phone camera',
  'component.gameLaunch.mobileTip': 'Use camera app to scan',
  'component.gameLaunch.copyForMobile': 'Copy URL for Mobile',
  'component.gameLaunch.openBrowser': 'Open in Browser',
  'component.copyAddress': 'Copy address',
  'component.copySuccess': 'Address copied',
  'component.endOfList': 'End of list',
};
